import { useTranslation } from 'react-i18next';
import { SingleInvoiceLineItem } from '..';
import SingleDeliveryItem from './SingleDeliveryItem';
import { fToCurrency } from '@web/utils/src';
import { Invoice } from '@/types';

type PInvoice = Pick<Invoice, 'totalNet' | 'totalGross'> & {
  lineItems: SingleInvoiceLineItem[];
};

interface InvoiceItemsTableProps {
  invoice: PInvoice;
}

const InvoiceItemsTable: React.FC<InvoiceItemsTableProps> = (props) => {
  const { invoice } = props;
  const { t } = useTranslation();

  return (
    <div>
      <div className="mb-1-0">
        <div className="flex text-1-2 font-bd p-1-0 border-b-2 border-primary-black">
          <div className="w-[15%]">
            <span>{t('orders.amount')}</span>
          </div>
          <div className="w-full">
            <span>{t('orders.product_title')}</span>
          </div>
          <div className="w-[10%]">
            <span>{t('orders.price')}</span>
          </div>
        </div>
        {invoice.lineItems ? (
          invoice.lineItems.map((item) => {
            return <SingleDeliveryItem key={item.id} item={item} />;
          })
        ) : (
          <p className="py-4-0 text-body1 text-center">
            {t('tables.no_result')}
          </p>
        )}
      </div>
      <div className="bg-primary-yellow font-bd text-1-2">
        <div className="flex justify-between p-1-0 border-b border-primary-black">
          <span>{t('checkout.total_net')}</span>
          <span className="w-[10%]">{fToCurrency(invoice.totalNet || 0)}</span>
        </div>
        <div className="flex justify-between p-1-0">
          <span>{t('checkout.total_gross')}</span>
          <div className="w-[10%]">{fToCurrency(invoice.totalGross || 0)}</div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceItemsTable;
